export default __webpack_public_path__ + "static/media/stylist_image_3.ee16c6b0.png";